import createCrudVuexModule from "@/store/crud";

export const accessRestriction = createCrudVuexModule({
  namespaced: true,
  path: "/library/access-restriction",
});

export const workspaceAccessRestriction = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/access-restriction",
});

export const managementAccessRestriction = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/access-restriction",
});
